import React, { useEffect, useState } from "react";
import ContentPage from "../Components/ContentPage";
import HomeIcon from "@mui/icons-material/Home";
import { useDispatch, useSelector } from "react-redux";
import { labList } from "../store/Slice/labSlice";
import DataTable from "../Components/Table/DataTable";
import {
  Avatar,
  Box,
  Button,
  Container,
  Divider,
  FormControl,
  Grid,
  InputLabel,
  Link,
  MenuItem,
  Paper,
  Select,
  Stack,
  Tab,
  Tabs,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import moment from "moment/moment";
import ChipStatus from "../Components/ChipStatus";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import { departmentDetailList } from "../store/Slice/departmentDetailSlice";
import { labFormList } from "../store/Slice/labFormSlice";
import SearchTwoToneIcon from "@mui/icons-material/SearchTwoTone";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import Number from "../Components/Number";
import { useLocation, useNavigate } from "react-router-dom";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import urlParams from "../Services/urlParams";
import PictureAsPdfTwoToneIcon from "@mui/icons-material/PictureAsPdfTwoTone";
import InsertDriveFileTwoToneIcon from "@mui/icons-material/InsertDriveFileTwoTone";
import { REPORT_FORM } from "../Config";
import { useDepartment } from './../features/LabStat/hooks/useDepartment';
import { useVisitDepartment } from './../features/LabStat/hooks/useVisitDepartment';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function Lablist() {
  const { RangePicker } = DatePicker;
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const lab = useSelector(({ lab }) => lab);
  const departmentDetail = useSelector(
    ({ departmentDetail }) => departmentDetail
  );
  const labForm = useSelector(({ labForm }) => labForm);
  const [dates, setDates] = useState(null);

  const { departmentName, fetchDepartmentByDate } = useDepartment();
  const { visitDepartmentName, fetchVisitDepartmentByDate } = useVisitDepartment();

  const [search, setSearch] = useState({
    startDate: dayjs().format("YYYY/MM/DD"),
    endDate: dayjs().format("YYYY/MM/DD"),
    search: "",
    department_detail_name: "",
    visit_department_detail_name: "",
    lab_form_name: "",
    patient_type: "",
    status: "",
  });
  const searchUrl = urlParams.generateUrlWithParams(search);

  useEffect(() => {
    const queryObject = urlParams.queryObject(location);
    if (queryObject) {
      // ตั้งค่า search เริ่มต้นจาก query object
      setSearch({
        startDate: queryObject.startDate || "",
        endDate: queryObject.endDate || "",
        search: queryObject.search || "",
        department_detail_name: queryObject.department_detail_name || "",
        visit_department_detail_name: queryObject.visit_department_detail_name || "",
        lab_form_name: queryObject.lab_form_name || "",
        patient_type: queryObject.patient_type || "",
        status: queryObject.status || "",
      });
      setDates([
        dayjs(queryObject.startDate || "", "YYYY/MM/DD"),
        dayjs(queryObject.endDate || "", "YYYY/MM/DD"),
      ]);
      dispatch(labList(queryObject));
      if (queryObject.status) {
        setValueTab(queryObject.status || "");
      }
    } else {
      setDates([dayjs(), dayjs()]);
      dispatch(labList(queryObject));
    }
    dispatch(departmentDetailList());
    dispatch(labFormList());
  }, []);

  const disabledDate = (current) => {
    if (!dates) {
      return false;
    }
    const tooLate = dates[0] && current.diff(dates[0], "days") >= 31;
    const tooEarly = dates[1] && dates[1].diff(current, "days") >= 31;
    return !!tooEarly || !!tooLate;
  };

  const onClickSearch = () => {
    // fetchDepartmentByDate({
    //   startDate: search.startDate || "",
    //   endDate: search.endDate || ""
    // });
    // fetchVisitDepartmentByDate({
    //   startDate: search.startDate || "",
    //   endDate: search.endDate || ""
    // });
    dispatch(labList(search));

    const searchUrl = `/lab?startDate=${search.startDate || ""}&endDate=${search.endDate || ""}&search=${search.search || ""}&department_detail_name=${search.department_detail_name || ""}&visit_department_detail_name=${search.visit_department_detail_name || ""}&lab_form_name=${search.lab_form_name || ""}&patient_type=${search.patient_type || ""}&status=${search.status || ""}`;
    navigate(searchUrl);
  };

  useEffect(() => {
    if (search.startDate && search.endDate) {
      // setSearch((prev) => ({
      //   ...prev,
      //   department_detail_name: "",
      //   visit_department_detail_name: "",
      // }));

      fetchDepartmentByDate({
        startDate: search.startDate,
        endDate: search.endDate,
      });
      fetchVisitDepartmentByDate({
        startDate: search.startDate,
        endDate: search.endDate,
      });
    }
  }, [search.startDate, search.endDate]);

  let status_list = [
    {
      name: "ทั้งหมด",
      value: "",
    },
    {
      name: "กำลังดำเนินการ",
      value: "กำลังดำเนินการ",
    },
    {
      name: "รายงานบางส่วน",
      value: "รายงานบางส่วน",
    },
    {
      name: "รายงานผลแล้ว",
      value: "รายงานผลแล้ว",
    },
  ];
  const [valueTab, setValueTab] = React.useState("");

  const handleChangeTab = (event, newValue) => {
    setValueTab(newValue);
    setSearch({ ...search, status: newValue });

    dispatch(labList({ ...search, status: newValue }));
  };

  const rows = lab.result;
  const columns = [
    {
      field: "#",
      headerName: "#",
      width: 30,
    },
    {
      field: "lab_order_status_name",
      headerName: "สถานะ",
      numeric: "center",
      width: 100,
      renderCell: ({ row }) => {
        return (
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <ChipStatus
              type={row.lab_order_status_name}
              title={row.lab_order_status_name}
            />
          </Box>
        );
      },
    },
    {
      field: "lab_order_id",
      headerName: "LN",
      renderCell: ({ row }) => {
        return (
          <Box sx={{ display: "flex", justifyContent: "flex-start" }}>
            <Tooltip
              title={
                row.lab_order_status_name !== "รายงานผลแล้ว"
                  ? "รอรายงานผลแล้ว"
                  : "รายละเอียด"
              }
              arrow
            >
              <Link
                component="button"
                variant="body2"
                underline={
                  row.lab_order_status_name !== "รายงานผลแล้ว"
                    ? "none"
                    : "always"
                }
                color={
                  row.lab_order_status_name !== "รายงานผลแล้ว"
                    ? "inherit"
                    : "primary"
                }
                onClick={() => {
                  if (row.lab_order_status_name === "รายงานผลแล้ว") {
                    navigate("detail/" + row.lab_order_id + searchUrl);
                  }
                }}
              >
                {row.lab_order_id}
              </Link>
            </Tooltip>
          </Box>
        );
      },
    },
    {
      field: "patient_name",
      headerName: "ชื่อ - นามสกุล",
    },
    {
      field: "patient_type",
      headerName: "ประเภท",
    },
    {
      field: "hn",
      headerName: "HN",
    },

    {
      field: "lab_order_number",
      headerName: "Ref. No.",
    },
    {
      field: "date_time",
      headerName: "วันที่ / เวลา",
      renderCell: ({ row }) => {
        return (
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
            }}
          >
            <CalendarMonthIcon fontSize="small" color="warning" />
            <Stack sx={{ ml: 1 }}>
              <Typography variant="body2">
                {moment(row.date_time).format("D/M/YYYY HH:mm")}
              </Typography>
            </Stack>
          </Box>
        );
      },
    },
    {
      field: "visit_department_detail_name",
      headerName: "จุดตรวจ",
    },
    {
      field: "department_detail_name",
      headerName: "จุดที่สั่ง",
    },
    {
      field: "ward_name",
      headerName: "Ward",
    },

    {
      field: "lab_form_name",
      headerName: "LAB Form",
    },
    {
      field: "Actions",
      headerName: "Actions",
      renderCell: ({ row }) => {
        return (
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
            }}
          >
            {row.lab_order_status_name === "รายงานผลแล้ว" && (
              <Tooltip title="พิมพ์ PDF" arrow>
                <Avatar
                  variant="rounded"
                  alt="พิมพ์"
                  sx={{ width: 27, height: 27, cursor: "pointer", mr: 1 }}
                  src={process.env.PUBLIC_URL + "/pdf.png"}
                  onClick={() => {
                    window.open(
                      `${REPORT_FORM}pdf/${row.lab_order_id}`,
                      "_blank"
                    );
                  }}
                />
              </Tooltip>
            )}
            {row.lab_order_status_name === "รายงานผลแล้ว" && (
              <Tooltip title="พิมพ์สติ๊กเกอร์" arrow>
                <Avatar
                  variant="rounded"
                  alt="พิมพ์สติ๊กเกอร์"
                  sx={{ width: 27, height: 27, cursor: "pointer", mr: 1 }}
                  src={process.env.PUBLIC_URL + "/stickerReport.png"}
                  onClick={() => {
                    window.open(
                      `${REPORT_FORM}sticker/${row.lab_order_id}`,
                      "_blank"
                    );
                  }}
                />
              </Tooltip>
            )}
            {row.lab_order_status_name === "รายงานผลแล้ว" && (
              <Tooltip title="พิมพ์รูป PDF" arrow>
                <Avatar
                  variant="rounded"
                  alt="พิมพ์รูป PDF"
                  sx={{ width: 27, height: 27, cursor: "pointer" }}
                  src={process.env.PUBLIC_URL + "/icons/google-docs.png"}
                  onClick={() => {
                    window.open(
                      `${REPORT_FORM}pdf_image/${row.lab_order_id}`,
                      "_blank"
                    );
                  }}
                />
              </Tooltip>
            )}
          </Box>
        );
      },
    },
  ];

  return (
    <ContentPage
      image_icon={process.env.PUBLIC_URL + "/icons/research.png"}
      title="All Lab Request"
      TitlePageMenulist={[
        {
          label: "หน้าแรก",
          href: "/lab",
          icon: <HomeIcon fontSize="small" />,
        },
      ]}
    >
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        spacing={2}
        mb={2}
      >
        <Grid item xs={12} md={4}>
          <Paper
            variant="outlined"
            sx={{
              borderRadius: 3,
              height: { xs: 110, md: 110 },
              p: 2,
              bgcolor: "#9e9e9e",
              color: "#fff",
            }}
          >
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={1}
            >
              <Grid item xs={4} md={12}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Typography variant="h5" sx={{ fontWeight: "bold" }}>
                    กำลังดำเนินการ
                  </Typography>
                </Box>
              </Grid>

              <Grid
                item
                xs={8}
                md={12}
                sx={{ display: "flex", justifyContent: "center" }}
              >
                <Typography
                  variant="h4"
                  color="gray"
                  sx={{ fontWeight: "bold", color: "#fff" }}
                >
                  <Number n={lab.count_in_progress} />
                </Typography>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
        <Grid item xs={12} md={4}>
          <Paper
            variant="outlined"
            sx={{
              borderRadius: 3,
              height: { xs: 110, md: 110 },
              p: 2,
              color: "#fff",
              bgcolor: "rgba(37, 139, 165, 0.8)",
            }}
          >
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={1}
            >
              <Grid item xs={4} md={12}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Typography variant="h5" sx={{ fontWeight: "bold" }}>
                    รายงานบางส่วน
                  </Typography>
                </Box>
              </Grid>
              <Grid
                item
                xs={8}
                md={12}
                sx={{ display: "flex", justifyContent: "center" }}
              >
                <Typography
                  variant="h4"
                  color="gray"
                  sx={{ fontWeight: "bold", color: "#fff" }}
                >
                  <Number n={lab.count_partial_report} />
                </Typography>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
        <Grid item xs={12} md={4}>
          <Paper
            variant="outlined"
            sx={{
              borderRadius: 3,
              height: { xs: 110, md: 110 },
              p: 2,
              color: "#fff",
              bgcolor: "rgba(30, 143, 86, 0.8)",
            }}
          >
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={1}
            >
              <Grid item xs={4} md={12}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Typography variant="h5" sx={{ fontWeight: "bold" }}>
                    รายงานผลแล้ว
                  </Typography>
                </Box>
              </Grid>
              <Grid
                item
                xs={8}
                md={12}
                sx={{ display: "flex", justifyContent: "center" }}
              >
                <Typography
                  variant="h4"
                  color="gray"
                  sx={{ fontWeight: "bold", color: "#fff" }}
                >
                  <Number n={lab.count_reported} />
                </Typography>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
      <Paper elevation={0} sx={{ p: 1 }}>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={2}
          mb={2}
        >
          <Grid item xs={12} md={4}>
            <RangePicker
              style={{
                width: "100%",
                borderColor: "rgba(0, 0, 0, 0.2)",
              }}
              size="large"
              value={dates}
              placeholder={["วันที่เริ่ม", "วันที่ถึง"]}
              disabledDate={disabledDate}
              defaultValue={[
                search.startDate ? dayjs(search.startDate, "YYYY/MM/DD") : null,
                search.endDate ? dayjs(search.endDate, "YYYY/MM/DD") : null,
              ]}
              onCalendarChange={(val) => {
                setDates(val);
              }}
              onChange={(val) => {
                setSearch({
                  ...search,
                  startDate:
                    val === null ? "" : dayjs(val[0]).format("YYYY/MM/DD"),
                  endDate:
                    val === null ? "" : dayjs(val[1]).format("YYYY/MM/DD"),
                });
              }}
              format={"DD/MM/YYYY"}
              changeOnBlur
            />
          </Grid>
          {departmentName && (
            <Grid item xs={12} md={4}>
              <FormControl fullWidth size="small">
                <InputLabel id="department_detail_name-label">
                  จุดสั่ง
                </InputLabel>
                <Select
                  labelId="department_detail_name-label"
                  id="department_detail_name"
                  value={search.department_detail_name}
                  label="จุดสั่ง"
                  MenuProps={MenuProps}
                  onChange={(e) => {
                    setSearch({
                      ...search,
                      department_detail_name: e.target.value,
                    });
                  }}
                >
                  <MenuItem value={""}>ทั้งหมด</MenuItem>
                  {departmentName.map((opt, i) => (
                    <MenuItem key={i} value={opt.department_detail_name}>
                      {opt.department_detail_name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          )}

          {visitDepartmentName && (
            <Grid item xs={12} md={4}>
              <FormControl fullWidth size="small">
                <InputLabel id="visit_department_detail_name-label">
                  จุดตรวจ
                </InputLabel>
                <Select
                  labelId="visit_department_detail_name-label"
                  id="visit_department_detail_name"
                  value={search.visit_department_detail_name}
                  label="จุดตรวจ"
                  MenuProps={MenuProps}
                  onChange={(e) => {
                    setSearch({
                      ...search,
                      visit_department_detail_name: e.target.value,
                    });
                  }}
                >
                  <MenuItem value={""}>ทั้งหมด</MenuItem>
                  {visitDepartmentName.map((opt, i) => (
                    <MenuItem key={i} value={opt.visit_department_detail_name}>
                      {opt.visit_department_detail_name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          )}
          {!lab.disable_lab_form && (
            <Grid item xs={12} md={4}>
              <FormControl fullWidth size="small">
                <InputLabel id="lab_form_name-label">LAB Form</InputLabel>
                <Select
                  labelId="lab_form_name-label"
                  id="lab_form_name"
                  value={search.lab_form_name}
                  label="LAB Form"
                  MenuProps={MenuProps}
                  onChange={(e) => {
                    setSearch({
                      ...search,
                      lab_form_name: e.target.value,
                    });
                  }}
                >
                  <MenuItem value={""}>ทั้งหมด</MenuItem>
                  {labForm.result.map((opt, i) => (
                    <MenuItem key={i} value={opt.lab_form_name}>
                      {opt.lab_form_name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          )}
          {!lab.disable_patient_type && (
            <Grid item xs={12} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel id="patient_type-label">ประเภทคนไข้</InputLabel>
                <Select
                  labelId="patient_type-label"
                  id="patient_type"
                  value={search.patient_type}
                  label="ประเภทคนไข้"
                  MenuProps={MenuProps}
                  onChange={(e) => {
                    setSearch({
                      ...search,
                      patient_type: e.target.value,
                    });
                  }}
                >
                  <MenuItem value={""}>ทั้งหมด</MenuItem>
                  <MenuItem value={"IPD"}>IPD</MenuItem>
                  <MenuItem value={"OPD"}>OPD</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          )}
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              id="outlined-basic"
              type="search"
              value={search.search}
              label="ค้นหา"
              size="small"
              variant="outlined"
              onChange={(e) => {
                setSearch({
                  ...search,
                  search: e.target.value,
                });
              }}
            />
          </Grid>

          <Grid item xs={12} md={1}>
            <Button
              variant="contained"
              fullWidth
              startIcon={<SearchTwoToneIcon />}
              onClick={onClickSearch}
            >
              ค้นหา
            </Button>
          </Grid>
        </Grid>
        <Paper>
          <Divider />
          <Tabs
            value={valueTab}
            onChange={handleChangeTab}
            aria-label="Tabs status"
          >
            {status_list.map((opt, i) => (
              <Tab key={i} value={opt.value} label={opt.name} />
            ))}
          </Tabs>
          <Divider sx={{ mb: 2 }} />
          <DataTable rows={rows} columns={columns} />
        </Paper>
      </Paper>
    </ContentPage>
  );
}
